import React from 'react';

import './content-logo.css';

export const ContentLogo = props => (
    <svg viewBox="0 0 698.541 386.203" {...props}>
        <g transform="translate(-92.5 -7.694)">
            <path
                className="a"
                d="M357,563.206C357,376.973,506.565,226,691.063,226s334.063,150.973,334.063,337.206Z"
                transform="translate(-248.511 -196.569)"
            />
            <g transform="translate(381.393 51.334)">
                <path
                    className="b"
                    d="M875.721,95.927l-184.93,92.855-10.255-20.425L865.466,75.5Z"
                    transform="translate(-680.536 -75.502)"
                />
                <path
                    className="c"
                    d="M688.463,168.059l4.634,9.231m-.117-11.5,3.156,6.284m.707-8.224L700,170.137m.707-8.225,3.155,6.285m.707-8.224,3.155,6.284m1.165-8.454,4.634,9.23m-.117-11.5,3.156,6.284m.707-8.224,3.156,6.284m.707-8.224,3.156,6.285m.707-8.224L728.148,156m1.165-8.454,4.634,9.23m-.117-11.5,3.155,6.285m.707-8.224,3.155,6.284m.707-8.223,3.155,6.284m.707-8.223,3.155,6.284m1.166-8.454,4.634,9.231m-.117-11.5,3.155,6.284m.707-8.224,3.155,6.285m.707-8.224,3.155,6.284m.707-8.224L769,135.491m1.165-8.454,4.635,9.23m-.117-11.5,3.155,6.284m.707-8.223,3.156,6.284m.707-8.224,3.155,6.285m.707-8.224,3.155,6.284m1.165-8.454,4.634,9.231m-.117-11.5,3.155,6.285m.707-8.224,3.155,6.284m.707-8.224,3.156,6.285m.707-8.225,3.156,6.285m1.165-8.454,4.635,9.229m-.118-11.5,3.156,6.285m.707-8.225,3.156,6.285m.707-8.224,3.155,6.284m.707-8.224,3.155,6.285m1.166-8.454,4.634,9.231M835.952,94l3.156,6.284m.707-8.224,3.156,6.284m.707-8.223,3.156,6.284m.707-8.223L850.7,94.47m1.164-8.454,4.634,9.231m-.117-11.5,3.155,6.285m.707-8.224,3.155,6.284m.707-8.223,3.156,6.284"
                    transform="translate(-683.431 -77.097)"
                />
                <path
                    className="b"
                    d="M975.6,100.563a1.978,1.978,0,1,1-2.655-.881,1.978,1.978,0,0,1,2.655.881Z"
                    transform="translate(-786.908 -84.255)"
                />
            </g>
            <path
                className="d"
                d="M556.054,107.578v-13.1l-10.063-.785a36.5,36.5,0,0,0-5.349-12.9l6.563-7.675-9.264-9.264-7.675,6.564a36.481,36.481,0,0,0-12.9-5.349L516.579,55h-13.1l-.785,10.064a36.479,36.479,0,0,0-12.9,5.349l-7.675-6.564-9.264,9.264,6.564,7.675a36.5,36.5,0,0,0-5.35,12.9L464,94.476v13.1l10.063.785a36.5,36.5,0,0,0,5.35,12.9l-6.564,7.675,9.265,9.264,7.675-6.564a36.479,36.479,0,0,0,12.9,5.349l.785,10.064h13.1l.785-10.064a36.489,36.489,0,0,0,12.9-5.349l7.674,6.564,9.264-9.264-6.563-7.675a36.5,36.5,0,0,0,5.349-12.9Z"
                transform="translate(-181.35 -16.681)"
            />
            <path
                className="e"
                d="M538.473,124.236A15.237,15.237,0,1,1,523.237,109,15.237,15.237,0,0,1,538.473,124.236Z"
                transform="translate(-198.996 -18.491)"
            />
            <path
                className="d"
                d="M543.473,119.236A15.236,15.236,0,1,1,528.237,104,15.237,15.237,0,0,1,543.473,119.236Z"
                transform="translate(-201.399 -17.564)"
            />
            <path
                className="f"
                d="M504,107.775A22.6,22.6,0,1,1,539.609,133"
                transform="translate(-197.863 -14.982)"
            />
            <path
                className="f"
                d="M550.407,124.628A30.131,30.131,0,1,1,502.928,91"
                transform="translate(-192.941 -13.817)"
            />
            <path
                className="g"
                d="M475.153,67.646V60.508l-5.483-.428a19.884,19.884,0,0,0-2.915-7.03l3.576-4.181-5.047-5.047L461.1,47.4a19.864,19.864,0,0,0-7.03-2.914L453.646,39h-7.138l-.428,5.483a19.864,19.864,0,0,0-7.03,2.915l-4.181-3.575-5.047,5.047,3.576,4.181a19.883,19.883,0,0,0-2.914,7.03L425,60.508v7.138l5.483.428A19.875,19.875,0,0,0,433.4,75.1l-3.575,4.181,5.047,5.047,4.181-3.575a19.876,19.876,0,0,0,7.03,2.914l.428,5.483h7.138l.428-5.483a19.875,19.875,0,0,0,7.03-2.915l4.181,3.576,5.047-5.047L466.756,75.1a19.876,19.876,0,0,0,2.914-7.03l5.483-.428Z"
                transform="translate(-160.049 -10.839)"
            />
            <path
                className="h"
                d="M475.153,67.646V60.508l-5.483-.428a19.884,19.884,0,0,0-2.915-7.03l3.576-4.181-5.047-5.047L461.1,47.4a19.864,19.864,0,0,0-7.03-2.914L453.646,39h-7.138l-.428,5.483a19.864,19.864,0,0,0-7.03,2.915l-4.181-3.575-5.047,5.047,3.576,4.181a19.883,19.883,0,0,0-2.914,7.03L425,60.508v7.138l5.483.428A19.875,19.875,0,0,0,433.4,75.1l-3.575,4.181,5.047,5.047,4.181-3.575a19.876,19.876,0,0,0,7.03,2.914l.428,5.483h7.138l.428-5.483a19.875,19.875,0,0,0,7.03-2.915l4.181,3.576,5.047-5.047L466.756,75.1a19.876,19.876,0,0,0,2.914-7.03l5.483-.428Z"
                transform="translate(-160.049 -10.839)"
            />
            <path
                className="e"
                d="M464.506,79.253A8.253,8.253,0,1,1,456.253,71,8.253,8.253,0,0,1,464.506,79.253Z"
                transform="translate(-169.465 -22.524)"
            />
            <path
                className="d"
                d="M467.506,74.253A8.253,8.253,0,1,1,459.253,66,8.253,8.253,0,0,1,467.506,74.253Z"
                transform="translate(-170.902 -20.698)"
            />
            <path
                className="f"
                d="M446,67.974a12.486,12.486,0,0,1,24.124,4.217,12.068,12.068,0,0,1-4.514,9.395"
                transform="translate(-168.88 -18.507)"
            />
            <g transform="translate(562.109 262.497)">
                <path
                    className="i"
                    d="M1022.226,460.247l-11.531,6.922V464.9l9.25-5.5-9.25-5.643v-2.22l11.531,6.86Zm18.946,0-11.531,6.922V464.9l9.25-5.5-9.25-5.643v-2.22l11.531,6.86Zm18.947,0-11.531,6.922V464.9l9.249-5.5-9.25-5.643v-2.22l11.531,6.86Zm18.947,0-11.531,6.922V464.9l9.25-5.5-9.25-5.643v-2.22l11.531,6.86Zm18.945,0-11.531,6.922V464.9l9.25-5.5-9.25-5.643v-2.22l11.531,6.86Z"
                    transform="translate(-1010.694 -451.537)"
                />
            </g>
            <g transform="translate(309.012 304.214)">
                <path
                    className="i"
                    d="M575.216,529.622,584.738,524v1.84L577.1,530.31l7.639,4.584v1.8l-9.523-5.572Zm-15.871,0L568.867,524v1.84l-7.639,4.471,7.639,4.584v1.8l-9.523-5.572Zm-15.236,0L553.631,524v1.84l-7.639,4.471,7.639,4.584v1.8l-9.523-5.572Zm-15.237,0L538.394,524v1.84l-7.639,4.471,7.639,4.584v1.8l-9.523-5.572Zm-15.871,0L522.523,524v1.84l-7.639,4.471,7.639,4.584v1.8L513,531.125Z"
                    transform="translate(-513 -524)"
                />
            </g>
            <path
                className="g"
                d="M807.94,380.884H514.695A6.692,6.692,0,0,1,508,374.193v-188.5A6.692,6.692,0,0,1,514.695,179H807.94a6.692,6.692,0,0,1,6.695,6.691v188.5a6.692,6.692,0,0,1-6.695,6.691"
                transform="translate(-223.598 -81.487)"
            />
            <path
                className="j"
                d="M752.562,36.713a40.746,40.746,0,0,0-53.1-22.382m41.253,27.2a27.958,27.958,0,0,0-36.434-15.356m25.123,19.96a15.746,15.746,0,0,0-20.519-8.649"
                transform="translate(-293.028 -0.73)"
            />
            <path
                className="k"
                d="M697.463,12.331a40.747,40.747,0,0,1,53.1,22.382"
                transform="translate(-292.06 0)"
            />
            <path
                className="l"
                d="M750.562,34.713a40.746,40.746,0,0,0-53.1-22.382"
                transform="translate(-292.06)"
            />
            <path
                className="k"
                d="M705.056,31.535A27.958,27.958,0,0,1,741.49,46.891"
                transform="translate(-294.236 -7.358)"
            />
            <path
                className="l"
                d="M741.489,46.891a27.958,27.958,0,0,0-36.434-15.356"
                transform="translate(-294.235 -7.357)"
            />
            <path
                className="m"
                d="M715.5,113v41.9"
                transform="translate(-296.141 -58.2)"
            />
            <path
                className="l"
                d="M732.826,58.52a15.746,15.746,0,0,0-20.519-8.649"
                transform="translate(-296.336 -14.383)"
            />
            <path
                className="n"
                d="M706.075,95.095a14.842,14.842,0,1,1,14.842-14.842A14.842,14.842,0,0,1,706.075,95.095Z"
                transform="translate(-287.003 -20.483)"
            />
            <path
                className="e"
                d="M707.482,94.839a7.179,7.179,0,1,1,7.179-7.179,7.179,7.179,0,0,1-7.179,7.179"
                transform="translate(-290.068 -25.986)"
            />
            <path
                className="o"
                d="M710.482,91.839a7.179,7.179,0,1,1,7.179-7.179,7.179,7.179,0,0,1-7.179,7.179"
                transform="translate(-291.504 -24.891)"
            />
            <path
                className="h"
                d="M807.94,380.884H514.695A6.692,6.692,0,0,1,508,374.193v-188.5A6.692,6.692,0,0,1,514.695,179H807.94a6.692,6.692,0,0,1,6.695,6.691v188.5a6.692,6.692,0,0,1-6.695,6.691Z"
                transform="translate(-223.598 -81.487)"
            />
            <path
                className="g"
                d="M539,360.73H807.543V209H539Z"
                transform="translate(-235.183 -91.629)"
            />
            <path
                className="p"
                d="M951.983,471.492A3.492,3.492,0,1,1,948.492,468a3.492,3.492,0,0,1,3.492,3.492Z"
                transform="translate(-406.287 -195.482)"
            />
            <path
                className="d"
                d="M771.419,538H680l9.883-40h71.653Z"
                transform="translate(-287.157 -210.845)"
            />
            <path
                className="d"
                d="M771.773,566.983H664.693A1.734,1.734,0,0,1,663,565.21v-3.436A1.735,1.735,0,0,1,664.692,560H771.773a1.734,1.734,0,0,1,1.692,1.774v3.436a1.733,1.733,0,0,1-1.691,1.774Z"
                transform="translate(-280.672 -258.02)"
            />
            <g transform="translate(303.705 117.345)">
                <path
                    className="q"
                    d="M906.692,383.788h34.393v-17.1H906.692Z"
                    transform="translate(-673.068 -266.535)"
                />
                <path
                    className="r"
                    d="M539.655,356.849h37.636v-17.1H539.655Zm37.95,17.1H604.31v-17.1H577.605Z"
                    transform="translate(-539.046 -256.698)"
                />
                <path
                    className="s"
                    d="M938.152,365.183h4.44v-2.612h-4.44Zm-25.025,0h4.44v-2.612h-4.44Z"
                    transform="translate(-675.418 -265.032)"
                />
                <path
                    className="r"
                    d="M599.433,356.849h26.705v-17.1H599.433Zm37.6,34.282h37.636v-17.1H637.03Zm37.95,0h26.705v-17.1H674.981Z"
                    transform="translate(-560.874 -256.698)"
                />
                <path
                    className="s"
                    d="M618.38,338.243h4.44v-2.612h-4.44Zm-12.513,0h4.44v-2.612h-4.44Zm51.028,34.071h4.44V369.7h-4.44Zm11.665,0H673V369.7h-4.44Zm-24.178,0h4.44V369.7h-4.44Zm-12.705,0h4.44V369.7h-4.44Zm63.071,0h4.44V369.7h-4.44Zm-12.513,0h4.44V369.7h-4.44Zm50.741,16.89h4.44v-2.613h-4.44Zm11.665,0h4.44v-2.613h-4.44Zm-24.178,0h4.44v-2.613h-4.44Zm-12.705,0h4.44v-2.613h-4.44Zm50.558,0h4.44v-2.613h-4.44Z"
                    transform="translate(-563.223 -255.195)"
                />
                <path
                    className="r"
                    d="M539.6,329.909h25.369v-17.1H539.6Z"
                    transform="translate(-539.026 -246.861)"
                />
                <path
                    className="s"
                    d="M558.547,311.3h4.44v-2.613h-4.44Zm-12.513,0h4.44v-2.613h-4.44Z"
                    transform="translate(-541.375 -245.358)"
                />
                <path
                    className="r"
                    d="M558.978,383.788h25.369v-17.1H558.978Z"
                    transform="translate(-546.102 -266.535)"
                />
                <path
                    className="r"
                    d="M539,383.788h12.684v-17.1H539Z"
                    transform="translate(-538.806 -266.535)"
                />
                <path
                    className="q"
                    d="M757.361,410.033h12.928V393.678H757.361Zm12.928.748h37.636v-17.1H770.289Zm37.951,0h14.385v-17.1H808.24Zm-226.726,0h48.969v-17.1H581.514Z"
                    transform="translate(-554.331 -276.391)"
                />
                <path
                    className="r"
                    d="M538.7,410.781h27.183v-17.1H538.7Z"
                    transform="translate(-538.696 -276.391)"
                />
                <path
                    className="q"
                    d="M896.785,437.405h33.193V420.3H896.785Zm40.723,0h-7.53V420.3h7.53Z"
                    transform="translate(-669.451 -286.113)"
                />
                <path
                    className="q"
                    d="M837.716,437.405h37.636V420.3H837.716Z"
                    transform="translate(-647.882 -286.113)"
                />
                <path
                    className="q"
                    d="M763.841,437.405h37.636V420.3H763.841Zm-25.863,0h25.369V420.3H737.978Z"
                    transform="translate(-611.463 -286.113)"
                />
                <path
                    className="q"
                    d="M718,437.405h12.684V420.3H718Z"
                    transform="translate(-604.167 -286.113)"
                />
                <path
                    className="r"
                    d="M658.715,437.405h37.636V420.3H658.715Z"
                    transform="translate(-582.521 -286.113)"
                />
                <path
                    className="r"
                    d="M584.661,437.405H622.3V420.3H584.661Zm-25.683,0h25.369V420.3H558.978Z"
                    transform="translate(-546.102 -286.113)"
                />
                <path
                    className="q"
                    d="M539,407.991h12.684v-17.1H539Zm245.908-51.141H797.59v-17.1H784.906Z"
                    transform="translate(-538.806 -256.698)"
                />
                <path
                    className="s"
                    d="M932.508,338.243h4.44v-2.612h-4.44Z"
                    transform="translate(-682.495 -255.195)"
                />
                <path
                    className="q"
                    d="M864.889,383.811h26.374v-17.1H864.889Z"
                    transform="translate(-657.804 -266.543)"
                />
                <path
                    className="s"
                    d="M884.991,365.206h4.44v-2.612h-4.44Zm-13.258,0h4.44v-2.612h-4.44Z"
                    transform="translate(-660.303 -265.04)"
                />
                <path
                    className="t"
                    d="M538.7,360.5H806.991V208.931H538.7Zm20.055-113.623,23.159-23.159m-23.159,41.927,34.108-34.107"
                    transform="translate(-538.696 -208.931)"
                />
            </g>
            <path
                className="g"
                d="M1150.407,201.527h-37.5a3.3,3.3,0,0,1-3.295-3.294V130.78a3.3,3.3,0,0,1,3.294-3.294h37.5a3.294,3.294,0,0,1,3.295,3.3v67.451a3.294,3.294,0,0,1-3.3,3.295"
                transform="translate(-490.17 -51.752)"
            />
            <path
                className="h"
                d="M1150.407,201.527h-37.5a3.3,3.3,0,0,1-3.295-3.294V130.78a3.3,3.3,0,0,1,3.294-3.294h37.5a3.294,3.294,0,0,1,3.295,3.3v67.451a3.294,3.294,0,0,1-3.3,3.295Z"
                transform="translate(-490.17 -51.752)"
            />
            <path
                className="u"
                d="M1118.306,192.7h33.05V137.2h-33.05Z"
                transform="translate(-492.726 -55.533)"
            />
            <path
                className="t"
                d="M1118.306,192.7h33.05V137.2h-33.05Z"
                transform="translate(-492.726 -55.533)"
            />
            <path
                className="t"
                d="M1128.288,172.763h20.376v-2.388h-20.376Zm0,9.192h20.376v-9.192h-20.376Z"
                transform="translate(-495.682 -68.75)"
            />
            <path
                className="v"
                d="M1131.451,178.626h11.444m-11.444,1.571h11.444m-11.444,1.57h11.444m1.613.442h3.474v-4.063h-3.474Z"
                transform="translate(-496.648 -71.88)"
            />
            <path
                className="w"
                d="M1145.728,133.14h-7.7a.423.423,0,0,1-.423-.423v-.31a.424.424,0,0,1,.423-.423h7.7a.424.424,0,0,1,.423.423v.31A.424.424,0,0,1,1145.728,133.14Z"
                transform="translate(-498.46 -24.884)"
            />
            <path
                className="p"
                d="M1145.551,233.806a2.862,2.862,0,1,1-2.862-2.862A2.862,2.862,0,0,1,1145.551,233.806Z"
                transform="translate(-499.126 -94.413)"
            />
            <g transform="translate(621.976 166.89)">
                <path
                    className="g"
                    d="M1313.677,374.541H1190.839a5.328,5.328,0,0,1-5.33-5.328v-72.37a5.328,5.328,0,0,1,5.328-5.328h122.839a5.328,5.328,0,0,1,5.328,5.328v72.369a5.328,5.328,0,0,1-5.328,5.328"
                    transform="translate(-1168.475 -291.515)"
                />
                <path
                    className="h"
                    d="M1313.677,374.541H1190.839a5.328,5.328,0,0,1-5.33-5.328v-72.37a5.328,5.328,0,0,1,5.328-5.328h122.839a5.328,5.328,0,0,1,5.328,5.328v72.369a5.328,5.328,0,0,1-5.328,5.328Z"
                    transform="translate(-1168.475 -291.515)"
                />
                <path
                    className="g"
                    d="M1198.685,370.309h116.766V304.344H1198.685Z"
                    transform="translate(-1173.286 -296.199)"
                />
                <path
                    className="t"
                    d="M1198.685,370.309h116.766V304.344H1198.685Z"
                    transform="translate(-1173.286 -296.199)"
                />
                <path
                    className="g"
                    d="M1318.488,430.047H1166.431a7.754,7.754,0,0,1-7.754-7.753h167.565a7.754,7.754,0,0,1-7.754,7.753"
                    transform="translate(-1158.677 -339.268)"
                />
                <path
                    className="h"
                    d="M1318.488,430.047H1166.431a7.754,7.754,0,0,1-7.754-7.753h167.565A7.754,7.754,0,0,1,1318.488,430.047Z"
                    transform="translate(-1158.677 -339.268)"
                />
                <path
                    className="h"
                    d="M1292.773,424.43h-21.886a2.136,2.136,0,0,1-2.136-2.136h26.159a2.136,2.136,0,0,1-2.136,2.136Z"
                    transform="translate(-1198.87 -339.268)"
                />
                <path
                    className="x"
                    d="M1275.178,366.443a5.084,5.084,0,0,1-.568.24,4.389,4.389,0,0,1-.648.173c.233.054.449.115.648.18a3.335,3.335,0,0,1,.568.247l5.989,3.027a.9.9,0,0,1,.373.306.718.718,0,0,1,.108.387v1.71l-10.312-5.363v-.986l10.312-5.35v1.694a.7.7,0,0,1-.108.395.91.91,0,0,1-.373.3Zm12.658,9.671a1.324,1.324,0,0,1-.54.693,1.419,1.419,0,0,1-.754.226h-1l8.017-19.967a1.339,1.339,0,0,1,.487-.654,1.3,1.3,0,0,1,.754-.227h1.014Zm22.183-9.75v.986l-10.312,5.363V371a.727.727,0,0,1,.108-.387.9.9,0,0,1,.373-.306l5.99-3.028a3.471,3.471,0,0,1,.568-.246c.2-.066.41-.127.632-.18a4.884,4.884,0,0,1-1.2-.413l-5.99-3.041a.9.9,0,0,1-.373-.3.708.708,0,0,1-.108-.394v-1.693l10.312,5.349Z"
                    transform="translate(-1206.166 -318.553)"
                />
                <path
                    className="t"
                    d="M1248.062,370.848h55.7V339.721h-55.7Zm0-31.13h55.7v-5.767h-55.7Z"
                    transform="translate(-1191.316 -307.01)"
                />
            </g>
            <path
                className="u"
                d="M813.008,370.966a2.231,2.231,0,0,0-4.424,0h-.022v-.5a2.281,2.281,0,0,0-2.192-2.3A2.231,2.231,0,0,0,804.1,370.4v-.629a2.28,2.28,0,0,0-2.192-2.3,2.231,2.231,0,0,0-2.275,2.228V361.3a2.279,2.279,0,0,0-2.192-2.3,2.23,2.23,0,0,0-2.275,2.227v16.585l-3.788-3.78a2.585,2.585,0,0,0-3.544-.135,2.525,2.525,0,0,0-.089,3.66l6.785,6.83a2.172,2.172,0,0,0,1.543.641h14.79a2.168,2.168,0,0,0,2.171-2.166v-.614l-.021-11.284Z"
                transform="translate(-332.667 -150.055)"
            />
            <path
                className="y"
                d="M818.453,373.788a2.691,2.691,0,0,0-5.35,0h-.026v-.612a2.792,2.792,0,0,0-2.651-2.846,2.667,2.667,0,0,0-1.941.787,2.787,2.787,0,0,0-.81,1.966v-.777a2.791,2.791,0,0,0-2.65-2.846,2.667,2.667,0,0,0-1.941.787,2.787,2.787,0,0,0-.81,1.967v-10.37A2.79,2.79,0,0,0,799.623,359a2.666,2.666,0,0,0-1.941.786,2.787,2.787,0,0,0-.81,1.966v20.5l-4.581-4.672a3.078,3.078,0,0,0-4.286-.166,3.168,3.168,0,0,0-.108,4.523l8.205,8.441a2.6,2.6,0,0,0,1.866.792h17.886a2.651,2.651,0,0,0,2.625-2.676v-.759l-.025-13.946Z"
                transform="translate(-338.116 -156.195)"
            />
            <g transform="translate(94 237.84)">
                <path
                    className="g"
                    d="M174.764,474.946H100.846A6.848,6.848,0,0,1,94,468.094V420.852A6.848,6.848,0,0,1,100.846,414h73.919a6.848,6.848,0,0,1,6.846,6.852v47.242a6.849,6.849,0,0,1-6.846,6.852"
                    transform="translate(-94 -414)"
                />
                <path
                    className="h"
                    d="M174.764,474.946H100.846A6.848,6.848,0,0,1,94,468.094V420.852A6.848,6.848,0,0,1,100.846,414h73.919a6.848,6.848,0,0,1,6.846,6.852v47.242A6.849,6.849,0,0,1,174.764,474.946Z"
                    transform="translate(-94 -414)"
                />
                <path
                    className="g"
                    d="M103,472.788h72.373V422H103Z"
                    transform="translate(-97.286 -416.921)"
                />
                <path
                    className="c"
                    d="M103,472.788h72.373V422H103Z"
                    transform="translate(-97.286 -416.921)"
                />
                <path
                    className="p"
                    d="M225.444,461.222A2.222,2.222,0,1,1,223.221,459a2.222,2.222,0,0,1,2.222,2.222Z"
                    transform="translate(-140.373 -430.431)"
                />
                <g transform="translate(18.483 22.659)">
                    <path
                        className="x"
                        d="M125.369,465.739q0-1.281-.044-2.165a5.451,5.451,0,0,0-.265-1.514,2.756,2.756,0,0,0-.674-1.073,5.3,5.3,0,0,0-1.272-.862v-.288a6.266,6.266,0,0,0,1.028-.652,2.92,2.92,0,0,0,.7-.785,3.292,3.292,0,0,0,.387-1.006,6.317,6.317,0,0,0,.121-1.315q0-1.569.1-2.763a5.138,5.138,0,0,1,.531-2,2.763,2.763,0,0,1,1.293-1.216,5.606,5.606,0,0,1,2.365-.409h.31a4.523,4.523,0,0,1,.066,1.337,3.672,3.672,0,0,1-.066.409,3.991,3.991,0,0,0-1.326.177,1.408,1.408,0,0,0-.741.586,2.554,2.554,0,0,0-.331,1.05,13.3,13.3,0,0,0-.077,1.569v.133a20.064,20.064,0,0,1-.089,2.056,5.417,5.417,0,0,1-.309,1.4,2.664,2.664,0,0,1-.586.929,3.4,3.4,0,0,1-.9.63,3.87,3.87,0,0,1,.9.652,2.659,2.659,0,0,1,.586.928,5.44,5.44,0,0,1,.309,1.4,20.053,20.053,0,0,1,.089,2.056v.155a13.065,13.065,0,0,0,.077,1.547,2.468,2.468,0,0,0,.331,1.039,1.478,1.478,0,0,0,.741.586,3.8,3.8,0,0,0,1.326.188,3.672,3.672,0,0,1,.066.408,4.387,4.387,0,0,1,0,.9q-.022.223-.066.443a7.709,7.709,0,0,1-2.2-.265,3.193,3.193,0,0,1-1.4-.819,3.113,3.113,0,0,1-.752-1.414,8.255,8.255,0,0,1-.221-2.033m43.274-11.517q0,1.282.044,2.166a5.48,5.48,0,0,0,.265,1.514,2.748,2.748,0,0,0,.674,1.072,5.3,5.3,0,0,0,1.272.863v.287a6.311,6.311,0,0,0-1.028.651,2.926,2.926,0,0,0-.7.785,3.279,3.279,0,0,0-.387,1.006,6.316,6.316,0,0,0-.121,1.315q0,1.569-.1,2.763a5.138,5.138,0,0,1-.531,2,2.766,2.766,0,0,1-1.293,1.216,5.606,5.606,0,0,1-2.365.409h-.31a4.524,4.524,0,0,1-.066-1.337,3.649,3.649,0,0,1,.066-.409,3.991,3.991,0,0,0,1.326-.177,1.411,1.411,0,0,0,.741-.586,2.563,2.563,0,0,0,.331-1.05,13.307,13.307,0,0,0,.077-1.569v-.133a20.064,20.064,0,0,1,.089-2.056,5.417,5.417,0,0,1,.309-1.4,2.668,2.668,0,0,1,.586-.929,3.4,3.4,0,0,1,.9-.63,3.868,3.868,0,0,1-.9-.652,2.665,2.665,0,0,1-.586-.929,5.435,5.435,0,0,1-.309-1.4,20.1,20.1,0,0,1-.089-2.057V454.8a13.065,13.065,0,0,0-.077-1.547,2.464,2.464,0,0,0-.331-1.039,1.478,1.478,0,0,0-.741-.586,3.784,3.784,0,0,0-1.327-.188,3.666,3.666,0,0,1-.065-.409,4.369,4.369,0,0,1,0-.9q.022-.221.066-.443a7.711,7.711,0,0,1,2.2.265,3.185,3.185,0,0,1,1.4.818,3.112,3.112,0,0,1,.752,1.416,8.252,8.252,0,0,1,.221,2.033m-34.174,7.315c-.037-.259-.069-.514-.1-.764a6.866,6.866,0,0,1-.041-.764,7.669,7.669,0,0,1,.041-.792c.028-.268.06-.532.1-.792a10.4,10.4,0,0,1,2.306-.083q.39.028.778.083.056.39.1.778a7.275,7.275,0,0,1,0,1.555q-.042.39-.1.779-.389.055-.764.083a10.4,10.4,0,0,1-1.542,0q-.39-.028-.778-.083m11.041,0c-.037-.259-.069-.514-.1-.764a6.87,6.87,0,0,1-.042-.764,7.676,7.676,0,0,1,.042-.792c.028-.268.06-.532.1-.792a10.4,10.4,0,0,1,2.306-.083c.26.018.519.046.778.083.038.26.07.519.1.778a7.441,7.441,0,0,1,0,1.555q-.042.39-.1.779-.389.055-.764.083a10.412,10.412,0,0,1-1.542,0q-.39-.028-.778-.083m11.041,0c-.038-.259-.07-.514-.1-.764a6.873,6.873,0,0,1-.041-.764,7.5,7.5,0,0,1,.041-.792c.028-.268.06-.532.1-.792a10.4,10.4,0,0,1,2.306-.083q.389.028.778.083.055.39.1.778a7.275,7.275,0,0,1,0,1.555q-.042.39-.1.779c-.26.037-.514.065-.764.083a10.4,10.4,0,0,1-1.543,0q-.39-.028-.778-.083"
                        transform="translate(-123.114 -449.691)"
                    />
                </g>
            </g>
            <g transform="translate(479.978 239.586)">
                <path
                    className="m"
                    d="M30,61A24.837,24.837,0,0,0,54.915,85.759h105.23"
                    transform="translate(-10.954 -22.274)"
                />
                <path
                    className="g"
                    d="M38.726,19.363A19.363,19.363,0,1,1,19.363,0,19.363,19.363,0,0,1,38.726,19.363"
                />
                <path
                    className="m"
                    d="M38.726,19.363A19.363,19.363,0,1,1,19.363,0,19.363,19.363,0,0,1,38.726,19.363Z"
                />
                <ellipse
                    className="a"
                    cx="10.793"
                    cy="10.158"
                    rx="10.793"
                    ry="10.158"
                    transform="translate(5.714 12.062)"
                />
                <path
                    className="o"
                    d="M34.315,25.158A10.158,10.158,0,1,1,24.158,15,10.157,10.157,0,0,1,34.315,25.158Z"
                    transform="translate(-5.112 -5.477)"
                />
                <path
                    className="z"
                    d="M247.7,94v7.618H235.721a.715.715,0,0,1-.721-.708v-6.2a.714.714,0,0,1,.721-.707Z"
                    transform="translate(-85.809 -34.324)"
                />
                <path
                    className="aa"
                    d="M265.793,98.585v1.368c0,.324-.66.586-1.477.586H255V98h9.316c.816,0,1.477.262,1.477.585Z"
                    transform="translate(-93.112 -35.784)"
                />
            </g>
            <g transform="translate(476.57 181.537)">
                <path
                    className="ab"
                    d="M.087,24.54H139.494"
                    transform="translate(-0.087 -9.155)"
                />
                <path
                    className="m"
                    d="M.087,23.305H139.494"
                    transform="translate(-0.087 -8.704)"
                />
                <path
                    className="ac"
                    d="M249.683,15.147A14.842,14.842,0,1,1,234.842.306a14.842,14.842,0,0,1,14.842,14.841Z"
                    transform="translate(-80.387 -0.306)"
                />
                <ellipse
                    className="a"
                    cx="8.053"
                    cy="8.571"
                    rx="8.053"
                    ry="8.571"
                    transform="translate(144.691 8.059)"
                />
                <path
                    className="ad"
                    d="M246.357,19.484a7.179,7.179,0,1,1-7.179-7.179,7.178,7.178,0,0,1,7.179,7.179"
                    transform="translate(-84.769 -4.687)"
                />
            </g>
            <g transform="translate(175.839 126.521)">
                <path
                    className="g"
                    d="M357.186,219h-53.33A2.863,2.863,0,0,0,301,221.87v29.575a2.863,2.863,0,0,0,2.856,2.87H345.02l8.45,8.491v-8.49h3.716a2.864,2.864,0,0,0,2.856-2.87V221.87a2.863,2.863,0,0,0-2.856-2.87"
                    transform="translate(-301 -219)"
                />
                <path
                    className="t"
                    d="M357.186,219h-53.33A2.863,2.863,0,0,0,301,221.87v29.575a2.863,2.863,0,0,0,2.856,2.87H345.02l8.45,8.491v-8.49h3.716a2.864,2.864,0,0,0,2.856-2.87V221.87A2.863,2.863,0,0,0,357.186,219Zm-44.758,10.158h1.9"
                    transform="translate(-301 -219)"
                />
                <path
                    className="ae"
                    d="M328,235h27.3"
                    transform="translate(-310.859 -224.842)"
                />
                <path
                    className="t"
                    d="M353.917,235h1.9M319,238.809h1.27"
                    transform="translate(-307.573 -224.842)"
                />
                <path
                    className="af"
                    d="M324,241h31.108"
                    transform="translate(-309.398 -227.033)"
                />
                <path
                    className="t"
                    d="M354.552,241h1.27M319,244.809h3.809"
                    transform="translate(-307.573 -227.033)"
                />
                <path
                    className="ag"
                    d="M328,247h26.029"
                    transform="translate(-310.859 -229.224)"
                />
                <path
                    className="t"
                    d="M352.012,247h3.809M319,250.809h1.9"
                    transform="translate(-307.573 -229.224)"
                />
                <path
                    className="ae"
                    d="M328,253h27.3"
                    transform="translate(-310.859 -231.415)"
                />
                <path
                    className="t"
                    d="M374,253h1.9"
                    transform="translate(-327.656 -231.415)"
                />
                <path
                    className="ah"
                    d="M319,258h36.187"
                    transform="translate(-307.573 -233.241)"
                />
                <g transform="translate(36.821 57.137)">
                    <path
                        className="g"
                        d="M398.874,340.108H361.025A2.032,2.032,0,0,1,359,338.07v-21a2.032,2.032,0,0,1,2.026-2.039h29.214l6-6.029v6.029h2.638a2.033,2.033,0,0,1,2.026,2.038v21a2.032,2.032,0,0,1-2.026,2.038"
                        transform="translate(-358.999 -309)"
                    />
                    <path
                        className="t"
                        d="M398.874,340.108H361.025A2.032,2.032,0,0,1,359,338.07v-21a2.032,2.032,0,0,1,2.026-2.039h29.214l6-6.029v6.029h2.638a2.033,2.033,0,0,1,2.026,2.038v21a2.032,2.032,0,0,1-2.026,2.038Zm-32.256-7.618h1.9"
                        transform="translate(-358.999 -309)"
                    />
                    <path
                        className="ai"
                        d="M381,346h15.237"
                        transform="translate(-367.033 -322.51)"
                    />
                    <path
                        className="t"
                        d="M395.124,344.539h1.9M371,342h1.27"
                        transform="translate(-363.381 -321.05)"
                    />
                    <path
                        className="aj"
                        d="M376,342h20.315"
                        transform="translate(-365.207 -321.05)"
                    />
                    <path
                        className="t"
                        d="M395.759,340.539h1.27M371,338h3.809"
                        transform="translate(-363.381 -319.589)"
                    />
                    <path
                        className="ak"
                        d="M380,338h15.871"
                        transform="translate(-366.667 -319.589)"
                    />
                    <path
                        className="t"
                        d="M393.22,336.539h3.809M371,334h1.9"
                        transform="translate(-363.381 -318.129)"
                    />
                    <path
                        className="ai"
                        d="M381,334h15.237"
                        transform="translate(-367.033 -318.129)"
                    />
                    <path
                        className="t"
                        d="M409,334h1.9"
                        transform="translate(-377.257 -318.129)"
                    />
                    <path
                        className="ah"
                        d="M371,330h26.029"
                        transform="translate(-363.381 -316.668)"
                    />
                </g>
            </g>
            <g transform="translate(166.373 228.077)">
                <path
                    className="g"
                    d="M208,408.919a14.919,14.919,0,1,1,14.919,14.919A14.92,14.92,0,0,1,208,408.919"
                    transform="translate(-208 -393.365)"
                />
                <ellipse
                    className="al"
                    cx="8.053"
                    cy="8.571"
                    rx="8.053"
                    ry="8.571"
                    transform="translate(5.714 6.983)"
                />
                <path
                    className="m"
                    d="M0,14.919A14.919,14.919,0,1,1,14.919,29.838,14.92,14.92,0,0,1,0,14.919Z"
                />
                <path
                    className="o"
                    d="M12,19.3a7.3,7.3,0,1,1,7.3,7.3A7.3,7.3,0,0,1,12,19.3"
                    transform="translate(-4.382 -4.382)"
                />
                <path
                    className="ab"
                    d="M225.347,23.53H33.849"
                    transform="translate(-12.36 -8.592)"
                />
                <path
                    className="m"
                    d="M205.8,24.5H45.5"
                    transform="translate(-16.614 -8.946)"
                />
            </g>
            <g transform="translate(162.17 170.427)">
                <path
                    className="n"
                    d="M674.726,355.363A19.363,19.363,0,1,1,655.363,336,19.363,19.363,0,0,1,674.726,355.363Z"
                    transform="translate(-424.594 -309.971)"
                />
                <path
                    className="e"
                    d="M669.49,361.745A11.745,11.745,0,1,1,657.745,350a11.745,11.745,0,0,1,11.745,11.745"
                    transform="translate(-428.245 -315.083)"
                />
                <path
                    className="g"
                    d="M671.315,360.158A10.158,10.158,0,1,1,661.158,350a10.158,10.158,0,0,1,10.158,10.158"
                    transform="translate(-430.071 -315.083)"
                />
                <path
                    className="am"
                    d="M671.315,360.158A10.158,10.158,0,1,1,661.158,350,10.158,10.158,0,0,1,671.315,360.158Z"
                    transform="translate(-430.071 -315.083)"
                />
                <path
                    className="an"
                    d="M308.714,302.618V295H320.69a.714.714,0,0,1,.721.708v6.2a.715.715,0,0,1-.721.707ZM303,299.347v-1.711a.758.758,0,0,1,.781-.732h4.932v3.174h-4.932A.758.758,0,0,1,303,299.347Z"
                    transform="translate(-303 -295)"
                />
                <path
                    className="m"
                    d="M524.361,342.266H483.647a20.7,20.7,0,0,1-20.775-20.633A20.7,20.7,0,0,0,442.1,301H332"
                    transform="translate(-313.589 -297.191)"
                />
            </g>
            <g transform="translate(393.121 93.688)">
                <path
                    className="g"
                    d="M39.678,75.954A19.461,19.461,0,1,1,20.217,56.493,19.461,19.461,0,0,1,39.678,75.954"
                    transform="translate(-0.756 -20.917)"
                />
                <path
                    className="ao"
                    d="M39.678,75.954A19.461,19.461,0,1,1,20.217,56.493,19.461,19.461,0,0,1,39.678,75.954Z"
                    transform="translate(-0.756 -20.917)"
                />
                <ellipse
                    className="a"
                    cx="10.164"
                    cy="10.165"
                    rx="10.164"
                    ry="10.165"
                    transform="translate(6.503 47.312)"
                />
                <path
                    className="g"
                    d="M35.728,81.3A10.164,10.164,0,1,1,25.564,71.137,10.164,10.164,0,0,1,35.728,81.3"
                    transform="translate(-6.103 -26.264)"
                />
                <path
                    className="am"
                    d="M35.728,81.3A10.164,10.164,0,1,1,25.564,71.137,10.164,10.164,0,0,1,35.728,81.3Z"
                    transform="translate(-6.103 -26.264)"
                />
                <path
                    className="ap"
                    d="M363.862.455h6.048a1.074,1.074,0,0,1,1.074,1.074v12.78a1.074,1.074,0,0,1-1.074,1.074h-6.048a2.587,2.587,0,0,1-2.587-2.587V3.042A2.587,2.587,0,0,1,363.862.455"
                    transform="translate(-132.399 -0.455)"
                />
                <path
                    className="am"
                    d="M363.862.455h6.048a1.074,1.074,0,0,1,1.074,1.074v12.78a1.074,1.074,0,0,1-1.074,1.074h-6.048a2.587,2.587,0,0,1-2.587-2.587V3.042A2.587,2.587,0,0,1,363.862.455Z"
                    transform="translate(-132.399 -0.455)"
                />
                <path
                    className="an"
                    d="M381.975,8.671h-5.407v-1.9h5.407a.662.662,0,0,1,.662.662V8.01A.662.662,0,0,1,381.975,8.671Zm0,5.309h-5.407v-1.9h5.407a.661.661,0,0,1,.662.661v.574A.661.661,0,0,1,381.975,13.981Z"
                    transform="translate(-137.982 -2.763)"
                />
                <path
                    className="m"
                    d="M62.065,60.072H222.729A14.242,14.242,0,0,0,236.97,45.83V26.922A13.923,13.923,0,0,1,250.893,13"
                    transform="translate(-23.143 -5.036)"
                />
            </g>
            <g transform="translate(231.458 259.356)">
                <path
                    className="aq"
                    d="M360.174,445v6.425m3.228-3.25H357"
                    transform="translate(-357 -445)"
                />
            </g>
            <g transform="translate(369.439 31.97)">
                <path
                    className="aq"
                    d="M624.174,45v6.425m3.228-3.25H621"
                    transform="translate(-621 -45)"
                />
            </g>
            <g transform="translate(609.338 162.94)">
                <path
                    className="aq"
                    d="M1083.174,277v6.425m3.228-3.25H1080"
                    transform="translate(-1080 -277)"
                />
            </g>
            <g transform="translate(289.393 86.611)">
                <path
                    className="aq"
                    d="M342.174,144v6.425m3.228-3.25H339"
                    transform="translate(-339 -144)"
                />
            </g>
            <g transform="translate(572.752 43.397)">
                <path
                    className="aq"
                    d="M1013.174,63v6.425m3.228-3.25H1010"
                    transform="translate(-1010 -63)"
                />
            </g>
            <g transform="translate(705.982 120.472)">
                <path
                    className="aq"
                    d="M1294.174,203v6.425m3.228-3.25H1291"
                    transform="translate(-1291 -203)"
                />
            </g>
            <g transform="translate(628.944 225.39)">
                <path
                    className="aq"
                    d="M1119.222,385.61v4.283m2.222-2.131H1117"
                    transform="translate(-1117 -385.61)"
                />
            </g>
            <g transform="translate(280.158 139.257)">
                <path
                    className="aq"
                    d="M452.222,235.61v4.283m2.222-2.131H450"
                    transform="translate(-450 -235.61)"
                />
            </g>
            <g transform="translate(114.315 163.514)">
                <path
                    className="aq"
                    d="M129.174,278v6.425m3.228-3.25H126"
                    transform="translate(-126 -278)"
                />
            </g>
            <g transform="translate(146.396 366.637)">
                <path
                    className="ar"
                    d="M286,674h47.614"
                    transform="translate(-192.386 -649.241)"
                />
                <path
                    className="as"
                    d="M1169.807,635h-14.6M993,635h148.873"
                    transform="translate(-622.6 -635)"
                />
                <path
                    className="ar"
                    d="M464.487,674H620.07m18.3,0H669.99m-217.983,0h-12.48M249,674h9.984m544.958,0h38.272"
                    transform="translate(-249 -649.241)"
                />
            </g>
            <path
                className="ar"
                d="M787.736,576.211H743.157c10.633-27.87-8.115-57.579-41.877-66.357s-69.748,6.7-80.381,34.57a50.094,50.094,0,0,0-34.845,6.06c-10,6.1-16.285,15.493-17.229,25.727H530.6c-1.484-22-21.961-39.915-48.48-42.413-7.255-28.923-34.4-51.638-69.331-58.022s-71.153,4.751-92.518,28.443c-24.744-5.154-50.957.635-69.277,15.3s-26.138,36.116-20.661,56.692H185"
                transform="translate(-33.228 -209.574)"
            />
            <g transform="translate(693.403 264.809) rotate(60)">
                <path
                    className="t"
                    d="M20.713,17.551C17.425,11.647,0,0,0,0"
                    transform="translate(0 1.732)"
                />
                <path
                    className="at"
                    d="M33.6,55.507H.678A.686.686,0,0,1,0,54.814V17.895a3.5,3.5,0,0,1,1.016-2.463L15.656.622a2.07,2.07,0,0,1,2.958,0l14.65,14.81a3.5,3.5,0,0,1,1.016,2.463V54.814a.7.7,0,0,1-.2.493A.67.67,0,0,1,33.6,55.507Z"
                    transform="translate(5.081 12.471)"
                />
                <ellipse
                    className="a"
                    cx="8.377"
                    cy="8.567"
                    rx="8.377"
                    ry="8.567"
                    transform="translate(12.576 33.664)"
                />
                <ellipse
                    className="at"
                    cx="8.377"
                    cy="8.567"
                    rx="8.377"
                    ry="8.567"
                    transform="translate(14.227 30.832)"
                />
                <path
                    className="au"
                    d="M0,0H18.862M0,4.688H18.862"
                    transform="translate(12.872 55.541)"
                />
                <ellipse
                    className="at"
                    cx="2.71"
                    cy="2.772"
                    rx="2.71"
                    ry="2.772"
                    transform="translate(19.646 18.707)"
                />
                <path
                    className="t"
                    d="M0,0S.708,3.16,1.67,4.241c1.921,2.154,4.452,4.372,6.8,8.155,4.163,6.714,6.612,13.209,10.3,9.617a2.039,2.039,0,0,0,.234-2.425"
                    transform="translate(2.032 0)"
                />
            </g>
            <g transform="translate(629.94 325.974) rotate(-60)">
                <path
                    className="t"
                    d="M20.713,17.551C17.425,11.647,0,0,0,0"
                    transform="translate(0 1.732)"
                />
                <path
                    className="at"
                    d="M33.6,55.507H.678A.686.686,0,0,1,0,54.814V17.895a3.5,3.5,0,0,1,1.016-2.463L15.656.622a2.07,2.07,0,0,1,2.958,0l14.65,14.81a3.5,3.5,0,0,1,1.016,2.463V54.814a.7.7,0,0,1-.2.493A.67.67,0,0,1,33.6,55.507Z"
                    transform="translate(5.081 12.471)"
                />
                <ellipse
                    className="a"
                    cx="8.377"
                    cy="8.567"
                    rx="8.377"
                    ry="8.567"
                    transform="translate(12.111 33.2)"
                />
                <ellipse
                    className="at"
                    cx="8.377"
                    cy="8.567"
                    rx="8.377"
                    ry="8.567"
                    transform="translate(14.227 30.832)"
                />
                <path
                    className="au"
                    d="M0,0H18.862M0,4.688H18.862"
                    transform="translate(12.872 55.541)"
                />
                <ellipse
                    className="at"
                    cx="2.71"
                    cy="2.772"
                    rx="2.71"
                    ry="2.772"
                    transform="translate(19.646 18.707)"
                />
                <path
                    className="t"
                    d="M0,0S.708,3.16,1.67,4.241c1.921,2.154,4.452,4.372,6.8,8.155,4.163,6.714,6.612,13.209,10.3,9.617a2.039,2.039,0,0,0,.234-2.425"
                    transform="translate(2.032 0)"
                />
            </g>
            <g transform="translate(448.883 106.664)">
                <path
                    className="aq"
                    d="M776.174,131v6.425m3.228-3.25H773"
                    transform="translate(-773 -131)"
                />
            </g>
        </g>
    </svg>
);
